export default {
  ExpiryText: Styles.color.grey.three,
  nameColor: Styles.color.grey.one,
};
